// extracted by mini-css-extract-plugin
export default {"pageNumber":"ZNuKpoEycGR_LTRUJ1Ag"};